export const POI_DISPLAY_TYPE = {
    DETAIL_IMAGE: 'DETAIL_IMAGE',
    LIST_IMAGE: 'LIST_IMAGE',
    KEY_WORDS: 'KEY_WORDS',
    TEXT: 'TEXT',
    DETAIL_DESC: 'DETAIL_DESC',
} as const;

export type PoiDisplayType = (typeof POI_DISPLAY_TYPE)[keyof typeof POI_DISPLAY_TYPE];

export const POI_FIELD_KEY = {
    POPUP_TYPE_SMALL: 'popupTypeSmall',
} as const;

export type PoiFieldKey = (typeof POI_FIELD_KEY)[keyof typeof POI_FIELD_KEY];
